import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormGroup } from 'reactstrap';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { StatesModel, StateEntities } from 'client/data/models/states';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';
import { FieldError } from 'site-modules/shared/components/field-error/field-error';
import { LP_ERROR_KEYS } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/constants/license-plate-constants';

export function LicensePlateTabStateCodeInputUI({
  stateCodes = [],
  stateCodeInputValue = '',
  onStateCodeChange,
  errorMap = {},
  isLocationStyleStep = false,
  isVinByAddressOverlay = false,
  isAppraisalValuePage = false,
  isEscapeHatch = false,
  isFontSize12 = false,
  isFontSize16 = false,
  isAddressTab = false,
}) {
  const uniqInputId = useId();

  const stateCodeInputName = 'state-code';
  const stateCodeInputId = `${stateCodeInputName}${uniqInputId}`;
  const hasStateCodeError = LP_ERROR_KEYS.STATE_CODE in errorMap;

  return (
    <FormGroup
      className={classnames(
        {
          'has-danger': hasStateCodeError,
          'ps-md-0_75 ps-lg-1': isLocationStyleStep,
          'text-start': isVinByAddressOverlay,
        },
        'form-group'
      )}
      noMargin
    >
      <StyledSelect
        id={stateCodeInputId}
        name={stateCodeInputName}
        labelText="State"
        labelClassName={classnames({
          'fw-bold': isAppraisalValuePage && !isEscapeHatch && !isLocationStyleStep && !isAddressTab,
          'size-12': isFontSize12,
          'size-14 text-gray-darker': isEscapeHatch,
          'size-16 text-start fw-bold': isVinByAddressOverlay && !isAddressTab,
        })}
        className={classnames({
          'text-gray-dark': isEscapeHatch,
          'size-16': isFontSize16,
          'size-14': !isFontSize16,
        })}
        toggle="Select State"
        labelKey="stateCode"
        valueKey="stateCode"
        options={stateCodes}
        value={stateCodeInputValue}
        onChange={onStateCodeChange}
        ariaDescribedBy={`${stateCodeInputId}-error`}
        ariaInvalid={hasStateCodeError}
        aria-required
        required
      />
      <FieldError
        id={`${stateCodeInputId}-error`}
        error={errorMap[LP_ERROR_KEYS.STATE_CODE]}
        classes="mt-0_5"
        isLiveRegion
      />
    </FormGroup>
  );
}

LicensePlateTabStateCodeInputUI.propTypes = {
  stateCodes: StateEntities.States,
  stateCodeInputValue: PropTypes.string,
  onStateCodeChange: PropTypes.func.isRequired,
  errorMap: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node])),
  isLocationStyleStep: PropTypes.bool,
  isVinByAddressOverlay: PropTypes.bool,
  isAppraisalValuePage: PropTypes.bool,
  isEscapeHatch: PropTypes.bool,
  isFontSize12: PropTypes.bool,
  isFontSize16: PropTypes.bool,
  isAddressTab: PropTypes.bool,
};

export const stateToPropsConfig = {
  stateCodes: bindToPath('allStateCodes', StatesModel),
};

export const LicensePlateTabStateCodeInput = connectToModel(LicensePlateTabStateCodeInputUI, stateToPropsConfig);
